<div class="content dark">
	<div class="row">
		<div class="col-lg-6">
			<div *ngIf="treenodes" class="tree-box">
				<tree-root class="asset-tree" [nodes]="treenodes" (activate)="ActivateNode($event.node)"></tree-root>
			</div>
			<div *ngIf="!treenodes">Loading...</div>
		</div>
		<div class="col-lg-6">
			<div *ngIf="selectedConfig">
				<div class="item-panel flush">
					<div class="heading">Select assets to use in calculations</div>
					<div class="content">
						<div *ngFor="let asset of selectedConfig.assets" class="form-group form-check">
							<label class="form-check-label"
								[title]="asset.acqcount < 20 ? 'Not enough acquisitions (at least 20 required)' : ''">
								<input [(ngModel)]="asset.checked" [disabled]="asset.acqcount < 20" class="form-check-input"
									type="checkbox">
								{{asset.fleet_name ? asset.fleet_name : "(No fleet)"}} / {{asset.asset_name}}
								({{asset.obcu_serial_number}})
							</label>
						</div>
						<app-action-button [action]="UpdateThresholds" [context]="this" processing="Generating...">Generate
							thresholds</app-action-button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="thresholdComponents !== null" class="row">
		<div class="col-lg-12">
			<div class="item-panel">
				<div class="heading">Thresholding results</div>
				<div *ngIf="thresholdComponents === undefined && !thresholdError" class="content">Loading...</div>
				<div *ngIf="thresholdComponents === undefined && thresholdError" class="content message-bad">{{thresholdError}}
				</div>
				<div *ngIf="thresholdComponents" class="content">
					<div class="row">
						<div class="col-md-6">
							<div class="row">
								<label class="col-md-3 col-form-label">Component:</label>
								<div class="col-md-9">
									<select class="form-control form-control-sm" [(ngModel)]="selectedComponent"
										(ngModelChange)="UpdateComponent($event)">
										<option *ngFor="let component of thresholdComponents" [ngValue]="component">
											{{component.description}}
											({{component.key}})</option>
									</select>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-3">Scale:</div>
								<div class="col-9">{{selectedComponent.thresholds.scale | roundlist : 4}}</div>
							</div>
							<div class="row mt-3">
								<div class="col-3">Offset:</div>
								<div class="col-9">{{selectedComponent.thresholds.offset | roundlist : 4}}</div>
							</div>
							<div class="row mt-3">
								<div class="col-3">Mean:</div>
								<div class="col-9">{{selectedComponent.thresholds.mean | roundlist : 4}}</div>
							</div>
							<div class="row mt-3">
								<div class="col-3">Warning:</div>
								<div class="col-9">{{selectedComponent.thresholds.warn | roundlist : 4}}</div>
							</div>
							<div class="row mt-3">
								<div class="col-3">Alarm:</div>
								<div class="col-9">{{selectedComponent.thresholds.alarm | roundlist : 4}}</div>
							</div>
						</div>
						<div class="col-md-6">
							<app-dvs-chart [options]="boxPlotOptions"></app-dvs-chart>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="newConfig" class="row">
		<div class="col-lg-6">
			<div class="item-panel flush">
				<div class="heading">Updated asset configuration</div>
				<div class="content">
					<textarea [(ngModel)]="newConfig" style="width: 100%;height: 400px;"></textarea>
				</div>
			</div>
		</div>
		<div class="col-lg-6">
			<p class="text-danger">Note: Updating the configuration will overwrite the existing configuration in the database!</p>
			<app-action-button [action]="UploadConfig" [context]="this" processing="Updating..." complete="Config updated">
				Update
				Config</app-action-button>
		</div>
	</div>
</div>